import { render, staticRenderFns } from "./CoursewareSelector.vue?vue&type=template&id=1b916270&scoped=true&"
import script from "./CoursewareSelector.vue?vue&type=script&lang=js&"
export * from "./CoursewareSelector.vue?vue&type=script&lang=js&"
import style0 from "./CoursewareSelector.vue?vue&type=style&index=0&id=1b916270&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b916270",
  null
  
)

export default component.exports